const state = {
  error: null,
  user: null,
};

const getters = {
  getAuthUser: (state) => state.user,
  getAuthError: (state) => state.error,
};

const actions = {
  authLogin({commit}, {email, password}) {
    window.axios.post('/api/auth/login', {
      email,
      password,
    }).then((response) => {
      window.axios.post('/api/auth/account').then((response) => {
        console.log(response);
        commit('SET_AUTH_USER', response.data.user);
        // window.location.reload();
        window.location = response.data.redirect;
      });
    }, (error) => {
      window.app.sweetalert('Oops!', error.response.data.message, 'error');
      commit('SET_AUTH_ERROR', error.response.data.message);
    });
  },
  authLogout({commit}) {
    window.axios.post('/api/auth/logout').then((response) => {
      commit('SET_AUTH_USER', null);
      if (window.location.pathname == '/') {
        window.location.reload();
      } else {
        window.location = '/';
      }
    }, (response) => {
      commit('SET_AUTH_ERROR', response.data);
    });
  },
};

const mutations = {
  SET_AUTH_USER(state, user) {
    state.user = user;
  },
  SET_AUTH_ERROR(state, error) {
    state.error = error;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./resources/js/store/modules/auth.js